
import axios from 'axios';

class userService {

    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL
        }
    }
    
    getUserList(username) {
        return axios.get(this.state.apiUrl + "admin/searchUser?username=" + username, { silent: true })
        .then(res => {
            return res.data;
        }).catch(err => {
            return err;
        });

    }
    
    getUserDetails(username) {
        return axios.get(this.state.apiUrl + "admin/viewUser?userId=" + username, { silent: true })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }

    updateUser(params) {
        return axios.put(this.state.apiUrl + "admin/updateUser", JSON.stringify(params))
        .then(res => {
            return res.data;
        }).catch(err => {
            return err;
        });
    }

    deleteUser(userId) {
        return axios.delete(this.state.apiUrl + "admin/deleteUser/" + userId)
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }

    saveUser(params) {
        return axios.post(this.state.apiUrl + "admin/saveUser", JSON.stringify(params))
        .then(res => {
            return res.data;
        }).catch(err => {
            return err;
        });
    }

    refreshUser(params) {
        return axios.post(this.state.apiUrl + "admin/refreshUser", JSON.stringify(params))
        .then(res => {
            return res.data;
        }).catch(err => {
            return err;
        });
    }

    fetchCustomerRelationship(userId) {
        return axios.get(this.state.apiUrl + "admin/fetchCustomerRelationship?userId=" + userId, { silent: true })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }

    updateUseRelation(params) {
        return axios.put(this.state.apiUrl + "admin/updateUseRelation", JSON.stringify(params))
        .then(res => {
            return res.data;
        }).catch(err => {
            return err;
        });
    }

}


export default userService;